export enum PageStatus {
    Draft = 'draft',
    Published = 'published',
    Archived = 'archived',
}